<nz-modal
  [(nzVisible)]="modalVisible"
  [nzTitle]="titleTpl"
  [nzWidth]="480"
  nzDraggable
  nzOkText="Generate JV"
  (nzOnOk)="handleOk()"
  nzCancelText="Cancel"
  (nzOnCancel)="handleCancel()"
>
  <ng-template #titleTpl>Generate SST Deemed Payment JV</ng-template>
  <ng-container *nzModalContent>
    <p style="margin-bottom: 16px;">
      There are invoices more than 12 months (Deemed Payment) with service tax
      required to be included in current taxable period.
    </p>
    <p style="margin-bottom: 16px;"> In order to proceed, Journal Entries are required to be generated. </p>
    <p>Do you want to proceed?</p>
  </ng-container>
</nz-modal>
